export default "__VITE_ASSET__CfCR3RaQ__"